import highEmphasis from '../../text/high-emphasis';

const secondary = (params) => highEmphasis(params);

export default secondary;
